const DataService = {

    // GET API call base
    async fetchData<T>(url: string): Promise<T> {
        let accessToken: string = sessionStorage.getItem("token")! ;
        const headers = { 'Authorization': 'Bearer ' + accessToken };
        const response = await fetch(url, { headers });
        if (!response.ok || response.status === 204) {          
            throw new Error(response.statusText);
        }
  
        const data = await response.json();
        return data as T;
    },

    // POST API call base
    async postData<T>(url: string, obj: any): Promise<T> {
        let accessToken: string = sessionStorage.getItem("token")! ;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + accessToken
        }

        const response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(obj),
            headers: headers
        });

        if (!response.ok) {
            throw new Error(response.statusText);
        }

        const result = await response.json();
        return result as T;
    }
}

export default DataService;